<template>
  <b-modal
    id="myiddup"
    ref="modal"
    title="중복관리"
    size="xl"
    scrollable
    @show="resetModal"
    @ok="handleOk"
    v-bind:hide-footer="true"
  >
    <b-container fluid class="bod">
      <div
        v-if="simlist.length == 0"
        style="
          height: 480px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <h4 style="color: blue">{{ result_txt }}</h4>
      </div>
      <div v-else>
        <div class="buttons">
          <b-button @click="prev">이전</b-button>
          <b-button @click="simconfirm" variant="danger">
            {{ notitext }}
          </b-button>
          <b-button @click="next">다음</b-button>
        </div>
        <b-row class="drow" style="margin-top: 15px">
          <b-col cols="2">원본 번호 </b-col>
          <b-col>
            <h4>{{ mid }}</h4>
            <h5>{{ plain_jimun_idf }}</h5>
            <h5 style="color: crimson">{{ tquestionmeta.qcode }}</h5>
          </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2">번호 </b-col>
          <b-col>
            <h5>
              {{ pos + 1 }}
            </h5>
          </b-col>
        </b-row>
        <b-row class="drow">
          <b-col cols="2"> 문제유형 </b-col>
          <b-col>
            {{ tquestionmeta.std_type }}
          </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2"> 지시문 </b-col>
          <b-col>{{ tquestionmeta.statement }} </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2"> 지문 </b-col>
          <b-col>
            <div v-html="tquestionmeta.jimun"></div>
          </b-col>
        </b-row>
        <b-row class="drow">
          <b-col cols="2"> 지문 단어수 </b-col>
          <b-col>
            {{ tquestionmeta.jimun_word_count }}
          </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2"> 원문 </b-col>
          <b-col v-html="tquestionmeta.plain_jimun"> </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2"> 원문단어수 </b-col>
          <b-col>
            {{ tquestionmeta.plain_jimun_word_count }}
          </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2"> 지문소재 </b-col>
          <b-col>
            {{ plain_jimun_subject_text }}
          </b-col>
        </b-row>

        <b-row class="drow" style="margin-bottom: 15px">
          <b-col cols="2"> 지문난이도 </b-col>
          <b-col>
            {{ plain_jimun_level }}
          </b-col>
        </b-row>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import * as _ from "lodash";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;
export default {
  props: ["main_metaid"],

  mounted() {
    let $this = this;
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      $this.tquestionmeta = {};
      $this.simlist = [];
      $this.tid = null;
      $this.result_txt = "검색중";

      // let url = `${SERVER_URL}/api/question_bank/metasim?main_metaid=${val}`;
      let val = this.plain_jimun_idf;
      let url = `${SERVER_URL}/api/question_bank/jimunsim/${val}?main_metaid=${this.mid}`;

      axios.get(url).then((resp) => {
        let data = resp.data;
        console.log(data);
        $this.simlist = data;

        if (data.length == 0 || data == null) {
          this.result_txt = "내용없음";
        }

        $this.tid = $this.simlist[0].target_metaid;

        this.loadQuestion();
      });
    });
  },

  computed: {
    mid() {
      return this.$store.state.questionmeta.id;
    },
    plain_jimun_idf() {
      return this.$store.state.questionmeta.plain_jimun_idf;
    },
    plain_jimun_subject_text() {
      try {
        let cd = this.tquestionmeta.plain_jimun_subject;
        let jimun_subject_options = this.$store.state.jimun_subject_options;
        let k = _.find(jimun_subject_options, function (o) {
          return o.value == cd;
        });
        return k.text;
      } catch {
        return "";
      }
    },
    plain_jimun_level() {
      return "level" + this.tquestionmeta.plain_jimun_level;
    },
  },
  data() {
    return {
      simlist: [],
      pos: 0,
      tid: null,
      tquestionmeta: {},
      notitext: "설정",
      result_txt: "",
    };
  },

  watch: {
    plain_jimun_idf: {
      immediate: true,
      handler(val, old) {
        if (val != null && val != "") {
          // let $this = this;
          // // let url = `${SERVER_URL}/api/question_bank/metasim?main_metaid=${val}`;
          // let url = `${SERVER_URL}/api/question_bank/jimunsim/${val}?main_metaid=${this.mid}`;
          // axios.get(url).then((resp) => {
          //   let data = resp.data;
          //   console.log(data);
          //   $this.simlist = data;
          //   $this.tid = $this.simlist[0].target_metaid;
          //   this.loadQuestion();
          // });
          console.log("dummy");
        } else {
          console.log("else statement");
        }
      },
    },
  },

  methods: {
    resetModal() {},
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {},
    prev() {
      if (this.pos > 0) {
        this.pos--;
        this.tid = this.simlist[this.pos].target_metaid;
        this.loadQuestion();
      }
    },
    next() {
      if (this.pos < this.simlist.length - 1) {
        this.pos++;
        this.tid = this.simlist[this.pos].target_metaid;
        this.loadQuestion();
      }
    },
    simconfirm() {
      console.log(this.tquestionmeta.id);
      let _id = this.tquestionmeta.id;

      let url = `${SERVER_URL}/api/question_bank/metasim`;

      axios
        .post(url, {
          main_metaid: this.mid,
          target_metaid: this.tid,
        })
        .then((resp) => {
          console.log("update");
        });

      if (this.notitext === "연관성 해제") {
        this.notitext = "연관성 설정";
      } else {
        this.notitext = "연관성 해제";
      }
    },

    loadQuestion() {
      let url = `${SERVER_URL}/question/${this.tid}`;
      let $this = this;
      axios.get(url).then((resp) => {
        let question = resp.data.question;
        this.tquestionmeta = resp.data.questionmeta;
        console.log(this.tquestionmeta.id);
        console.log($this.mid);

        //todo: check this id already check in the
        let url2 = `${SERVER_URL}/api/question_bank/matchsim?main_metaid=${$this.mid}&target_metaid=${this.tquestionmeta.id}`;
        axios.get(url2).then((resp2) => {
          console.log(resp2.data);
          if (resp2.data > 0) {
            $this.notitext = "연관성 해제";
          } else {
            $this.notitext = "연관성 설정";
          }
        });
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.drow {
  border-bottom: 1px solid lightgray;
  padding: 8px 0 8px 0;
}
.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>